import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import Button from '@adsk/bim360-matrix-react-button';
import SaveButton from '@adsk/bim360-matrix-react-save-button';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';

import './_EntityPickerModalFooter.scss';

const EntityPickerModalFooter = ({
  selectedEntitiesCount,
  clearSelectedEntities,
  onCancel,
  onSave,
  isSaving
}) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  return (
    <div className="EntityPickerModalFooter">
      <div className="EntityPickerModalFooter__left">
        {selectedEntitiesCount > 0 && (
          <Button
            styleType={Button.StyleType.INLINE_LINK}
            onClick={clearSelectedEntities}
            className="EntityPickerModalFooter__clear-items"
            disabled={isSaving}
          >
            {T.translate('CLEAR_ITEMS', { count: selectedEntitiesCount })}
          </Button>
        )}
      </div>
      <div className="EntityPickerModalFooter__right">
        <Button
          styleType={Button.StyleType.LINK_SECONDARY}
          onClick={onCancel}
          className="EntityPickerModalFooter__cancel-button"
          disabled={isSaving}
        >
          {T.translate('CANCEL')}
        </Button>
        <SaveButton
          saveText={T.translate('ADD')}
          savingText={T.translate('ADDING')}
          onSave={onSave}
          isSaving={isSaving}
          disabled={!selectedEntitiesCount}
        />
      </div>
    </div>
  );
};

EntityPickerModalFooter.propTypes = {
  /**
   * Number of selected entities.
   */
  selectedEntitiesCount: PropTypes.number,
  /**
   * Callback to clear all selected entities
   */
  clearSelectedEntities: PropTypes.func.isRequired,
  /**
   * Save button click handler.
   */
  onSave: PropTypes.func.isRequired,
  /**
   * Whether we're currently in saving process.
   */
  isSaving: PropTypes.bool,
  /**
   * Cancel button click handler.
   */
  onCancel: PropTypes.func.isRequired
};

export default EntityPickerModalFooter;
